import './../Input/input.css';

import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { Command as CommandPrimitive } from 'cmdk';
import React from 'react';

import { cn } from '@/services/utils';

import { Icon } from '../Icon';

const CommandInput = React.forwardRef<
    React.ElementRef<typeof CommandPrimitive.Input>,
    React.ComponentPropsWithoutRef<typeof CommandPrimitive.Input>
>(({ className, ...props }, ref) => (
    <div className="tw-flex tw-items-center tw-border-b tw-px-3">
        <div className="tw-mr-2">
            <Icon variant="dark" size="sm" icon={MagnifyingGlassIcon} />
        </div>
        <CommandPrimitive.Input
            ref={ref}
            className={cn(
                `input
                 tw-flex
                 tw-h-9
                 tw-w-full
                 tw-bg-transparent
                 tw-px-3
                 tw-py-2
                 lg-font-dynamic
                 tw-ring-offset-background
                 disabled:tw-cursor-not-allowed
                 disabled:tw-opacity-50`,
                className
            )}
            {...props}
        />
    </div>
));

CommandInput.displayName = CommandPrimitive.Input.displayName;

export { CommandInput };
